export function getElementProxies() {
    return [FLUIDRichTextEditor()];
}
var FLUIDRichTextEditor = function (useLocal) {
    if (useLocal === void 0) { useLocal = false; }
    var source = useLocal
        ? 'http://localhost:3335/build'
        : 'https://fluid-rich-text-editor.lmig.com/build';
    return {
        componentName: 'FLUID Rich Text Editor',
        selector: 'fluid-rich-text-editor',
        jsSource: "".concat(source, "/fluid-rte.js"),
        esmSource: "".concat(source, "/fluid-rte.esm.js"),
        sandboxDefinition: {
            component: 'fluid-rich-text-editor',
            props: {
                updateStrategy: 'input',
                label: 'My RTE',
                helpText: 'This is the RTE',
                outputFormat: 'text',
            },
            events: [
                {
                    eventKey: 'valueChange',
                    handler: function (event) {
                        return console.log('VALUE CHANGED', event.detail);
                    },
                },
                {
                    eventKey: 'contentChanged',
                    handler: function (event) {
                        return console.log('CONTENT CHANGED', event.detail);
                    },
                },
            ],
        },
    };
};
